var map = {
	"./crown-to-e-crown.png": "Wf8Y",
	"./electro.png": "QYaT",
	"./innovation.png": "OCx6",
	"./iphone.png": "o0da",
	"./multi-functional.png": "VrtV",
	"./nerve.png": "V8fz",
	"./self-learning.png": "LY/X",
	"./self-regulating.png": "e6dz",
	"./self-setting.png": "Zxxc",
	"./self-sufficient-1.png": "oa+D",
	"./self-sufficient-2.png": "Qz16",
	"./self-sufficient.png": "QIKX",
	"./touch.png": "ldPr",
	"./type-2-logo.png": "Doyw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lCRX";


//////////////////
// WEBPACK FOOTER
// ./src/img/innovations ^\.\/.*$
// module id = lCRX
// module chunks = 1